export enum BrandKitSwatchClusterVariant {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

export interface BrandKitSwatchClusterProps {
  logoURL?: string;
  colorHexes: string[];
  variant?: BrandKitSwatchClusterVariant;
}

export const BRAND_KIT_SWATCH_COLORS_LIMIT = 2;
